import React from "react";
import { PublicPage, SubTitle } from "../components/PublicPage";
import { useLang } from "../i18n";

const EMAIL = "info@riseyourlife.it";
const TEXT = {
  it: {
    title: "Contatti",
    pre: "Per informazioni sul programma, richieste delle aziende e questioni sulla privacy scrivici a ", post: ".",
    subject: "Richiesta informazioni RISE your LIFE",
    s1: "Titolare del servizio",
    t1: "MDS – MED SRL, Largo Repubblica 7, 20854 Vedano al Lambro (MB) — P.IVA 11999300962 — REA: MB 2633857.",
    s2: "I tuoi dati personali",
    t2pre: "Per esercitare i tuoi diritti scrivi a ", t2post: " indicando il nome e l'email del tuo account.",
  },
  en: {
    title: "Contact",
    pre: "For information about the programme, requests from companies and privacy matters, write to ", post: ".",
    subject: "Request for information RISE your LIFE",
    s1: "Service owner",
    t1: "MDS – MED SRL, Largo Repubblica 7, 20854 Vedano al Lambro (MB), Italy — VAT no. 11999300962 — REA: MB 2633857.",
    s2: "Your personal data",
    t2pre: "To exercise your rights, write to ", t2post: " stating the name and email of your account.",
  },
};

const Mail = ({ subject, testid }) => (
  <a href={`mailto:${EMAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`} className="text-[#B5651D] hover:underline" data-testid={testid}>{EMAIL}</a>
);

export default function Contact() {
  const { lang } = useLang();
  const c = TEXT[lang] || TEXT.it;
  return (
    <PublicPage title={c.title}>
      <p>{c.pre}<Mail subject={c.subject} testid="contact-email-link" />{c.post}</p>
      <section>
        <SubTitle>{c.s1}</SubTitle>
        <p>{c.t1}</p>
      </section>
      <section>
        <SubTitle>{c.s2}</SubTitle>
        <p>{c.t2pre}<Mail testid="contact-rights-email-link" />{c.t2post}</p>
      </section>
    </PublicPage>
  );
}
